/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ServiceContactIndividualType } from './ServiceContactIndividualType';
import {
	ServiceContactIndividualTypeFromJSON,
	ServiceContactIndividualTypeFromJSONTyped,
	ServiceContactIndividualTypeToJSON,
} from './ServiceContactIndividualType';
import type { UserProfileDetails } from './UserProfileDetails';
import {
	UserProfileDetailsFromJSON,
	UserProfileDetailsFromJSONTyped,
	UserProfileDetailsToJSON,
} from './UserProfileDetails';

/**
 * A payload that will add a service contact to a client organization. One of actorRID or details should be present in the payload.
 * @export
 * @interface AddServiceContact
 */
export interface AddServiceContact {
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof AddServiceContact
	 */
	actorRID?: string;
	/**
	 *
	 * @type {UserProfileDetails}
	 * @memberof AddServiceContact
	 */
	details?: UserProfileDetails;
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof AddServiceContact
	 */
	metadataSchemaRID?: string;
	/**
	 *
	 * @type {object}
	 * @memberof AddServiceContact
	 */
	metadata?: object;
	/**
	 *
	 * @type {ServiceContactIndividualType}
	 * @memberof AddServiceContact
	 */
	contactType?: ServiceContactIndividualType;
}

/**
 * Check if a given object implements the AddServiceContact interface.
 */
export function instanceOfAddServiceContact(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function AddServiceContactFromJSON(json: any): AddServiceContact {
	return AddServiceContactFromJSONTyped(json, false);
}

export function AddServiceContactFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): AddServiceContact {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		actorRID: !exists(json, 'actorRID') ? undefined : json['actorRID'],
		details: !exists(json, 'details')
			? undefined
			: UserProfileDetailsFromJSON(json['details']),
		metadataSchemaRID: !exists(json, 'metadataSchemaRID')
			? undefined
			: json['metadataSchemaRID'],
		metadata: !exists(json, 'metadata') ? undefined : json['metadata'],
		contactType: !exists(json, 'contactType')
			? undefined
			: ServiceContactIndividualTypeFromJSON(json['contactType']),
	};
}

export function AddServiceContactToJSON(value?: AddServiceContact | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		actorRID: value.actorRID,
		details: UserProfileDetailsToJSON(value.details),
		metadataSchemaRID: value.metadataSchemaRID,
		metadata: value.metadata,
		contactType: ServiceContactIndividualTypeToJSON(value.contactType),
	};
}
